/* eslint-disable */
import { API_MAP, API_VMP_CHECK_LOGIN_INFO, API_WHITEBOARD } from "../../../modules/API/constants_ts";
import axiosClient from "./axiosClient";
class apiManagerWB {
    constructor() {
        this.checkLoginInfo = () => {
            return axiosClient.get(API_VMP_CHECK_LOGIN_INFO);
        };
        this.apiWB = (data) => {
            return axiosClient.post(API_WHITEBOARD, data);
        };
        this.fetchData = (url) => {
            return axiosClient.get(url);
        };
        this.getTotal = () => {
            return axiosClient.get(API_MAP.WHITEBOARD.GET_TOTAL);
        };
        this.getListSub = async ({ startDate, endDate, ...restQuery }) => {
            var url = `?start_time_search=${startDate}&end_time_search=${endDate}`;
            if (restQuery) {
                for (let [query, value] of Object.entries(restQuery)) {
                    url = url + `&${query}=${value}`;
                }
            }
            return axiosClient.get(API_MAP.CAPTIONS.GET_LIST_SUB + url);
        };
    }
}
export default new apiManagerWB();
